import React from 'react';
import { Venue } from '../../context/PortalContext';
import styles from './VenueSelector.module.css';

interface VenueSelectorProps {
  venues: Venue[];
  selectedVenueId: string;
  onVenueChange: (venueId: string) => void;
  label?: string;
  placeholder?: string;
  className?: string;
}

const VenueSelector: React.FC<VenueSelectorProps> = ({
  venues,
  selectedVenueId,
  onVenueChange,
  label = "Select Venue",
  placeholder = "Choose a venue...",
  className = ""
}) => {
  const selectedVenue = venues.find(v => v.id === selectedVenueId);

  return (
    <div className={`${styles.venueSelector} ${className}`}>
      <div className={styles.selectorHeader}>
        <label className={styles.selectorLabel}>{label}</label>
        {selectedVenue && (
          <div className={styles.selectedVenueInfo}>
            <span className={styles.venueName}>{selectedVenue.name}</span>
          </div>
        )}
      </div>
      
      <div className={styles.selectorWrapper}>
        <select
          value={selectedVenueId}
          onChange={(e) => onVenueChange(e.target.value)}
          className={styles.venueSelect}
        >
          <option value="" disabled>
            {placeholder}
          </option>
          {venues.map(venue => (
            <option key={venue.id} value={venue.id}>
              {venue.name} - {venue.city}, {venue.state}
            </option>
          ))}
        </select>
        <div className={styles.selectorIcon}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default VenueSelector;
